<template>
  <div class="contact-list-area">
    <div class="container-fluid">
      <div v-if="loading" class="text-center p-5">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">A carregar...</span>
        </div>
      </div>

      <div v-else class="table-responsive scroll-bar">
        <table class="table align-middle mb-0">
          <thead>
            <tr>
              <th>Utilizador</th>
              <th>Role</th>
              <th>Data de Criação</th>
              <th v-if="isSuperAdmin">Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="user in users" :key="user.id">
              <td>
                <div class="form-check d-flex align-items-center">
                  <label class="form-check-label ms-2">
                    <img class="rounded-circle me-3 border" src="../../assets/images/user/user-1.png" alt="user"
                      width="40" />
                  </label>
                  <div class="info">
                    <h4>{{ user.name || 'Sem Nome' }}</h4>
                    <a :href="'mailto:' + user.email">{{ user.email }}</a>
                  </div>
                </div>
              </td>
              <td>
                <span :class="getRoleBadgeClass(user.role)">{{ user.role }}</span>
              </td>
              <td>
                <span class="location">{{ formatDate(user.createdAt) }}</span>
              </td>
              <td v-if="isSuperAdmin">
                <ul class="d-flex justify-content-start list-unstyled mb-0">
                  <li class="me-2">
                    <a href="javascript:void(0)" @click="$emit('edit-user', user)">
                      <img src="../../assets/images/icon/note-2.svg" alt="edit" width="20">
                    </a>
                  </li>
                  <li>
                    <a href="javascript:void(0)" @click="$emit('confirm-delete', user)">
                      <img src="../../assets/images/icon/trash-2.svg" alt="delete" width="20">
                    </a>
                  </li>
                </ul>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import usersService from '../../services/usersService';
import authService from '../../services/authService';

export default {
  name: 'ContactList',
  data() {
    return {
      users: [],
      loading: true,
    };
  },
  computed: {
    isSuperAdmin() {
      const user = authService.getUser();
      return user?.role === 'SUPERADMIN';
    }
  },
  mounted() {
    this.loadUsers();
  },
  methods: {
    async loadUsers() {
      this.loading = true;
      try {
        this.users = await usersService.getAll();
      } catch (err) {
        console.error('Erro ao carregar utilizadores:', err);
      } finally {
        this.loading = false;
      }
    },
    formatDate(dateStr) {
      if (!dateStr) return '-';
      return new Date(dateStr).toLocaleDateString('pt-PT');
    },
    getRoleBadgeClass(role) {
      return {
        'badge bg-danger': role === 'SUPERADMIN',
        'badge bg-primary': role === 'ADMIN',
      };
    },
  },
};
</script>

<style scoped>
.badge {
  padding: 8px 12px;
  border-radius: 4px;
}
</style>
